
/* SERVICE_TYPE */
export const GET_SERVICE_TYPE_LISTING = "GET_SERVICE_TYPE_LISTING";
export const GET_SERVICE_TYPE_LISTING_SUCCESS = "GET_SERVICE_TYPE_LISTING_SUCCESS";
export const GET_SERVICE_TYPE_LISTING_FAIL = "GET_SERVICE_TYPE_LISTING_FAIL";

export const GET_SERVICE_TYPE_DETAILS = "GET_SERVICE_TYPE_DETAILS";
export const GET_SERVICE_TYPE_DETAILS_SUCCESS = "GET_SERVICE_TYPE_DETAILS_SUCCESS";
export const GET_SERVICE_TYPE_DETAILS_FAIL = "GET_SERVICE_TYPE_DETAILS_FAIL";

export const ADD_SERVICE_TYPE = "ADD_SERVICE_TYPE";
export const ADD_SERVICE_TYPE_SUCCESS = "ADD_SERVICE_TYPE_SUCCESS";
export const ADD_SERVICE_TYPE_FAIL = "ADD_SERVICE_TYPE_FAIL";

export const UPDATE_SERVICE_TYPE = "UPDATE_SERVICE_TYPE";
export const UPDATE_SERVICE_TYPE_SUCCESS = "UPDATE_SERVICE_TYPE_SUCCESS";
export const UPDATE_SERVICE_TYPE_FAIL = "UPDATE_SERVICE_TYPE_FAIL";

export const DELETE_SERVICE_TYPE = "DELETE_SERVICE_TYPE";
export const DELETE_SERVICE_TYPE_SUCCESS = "DELETE_SERVICE_TYPE_SUCCESS";
export const DELETE_SERVICE_TYPE_FAIL = "DELETE_SERVICE_TYPE_FAIL";

export const BULK_DELETE_SERVICE_TYPE = "BULK_DELETE_SERVICE_TYPE";
export const BULK_DELETE_SERVICE_TYPE_SUCCESS = "BULK_DELETE_SERVICE_TYPE_SUCCESS";
export const BULK_DELETE_SERVICE_TYPE_FAIL = "BULK_DELETE_SERVICE_TYPE_FAIL";

export const EXPORT_SERVICE_TYPE = "EXPORT_SERVICE_TYPE";
export const EXPORT_SERVICE_TYPE_SUCCESS = "EXPORT_SERVICE_TYPE_SUCCESS";
export const EXPORT_SERVICE_TYPE_FAIL = "EXPORT_SERVICE_TYPE_FAIL";

export const RESET_SERVICE_TYPE_STATE = 'RESET_SERVICE_TYPE_STATE';
export const RESET_SERVICE_TYPE_ATTACHMENT_STATE = 'RESET_SERVICE_TYPE_ATTACHMENT_STATE';